import { enqueueSnackbar } from "notistack";


export function throwError(error: any){
    enqueueSnackbar({message: error?.response?.data?.detail || error?.message || "Ошбика сервера, обратитесь в тех. поддержку", variant:"error"})
}

export function throwErrorText(text: string){
    enqueueSnackbar({message: text, variant:"error"})
}